import {BaseDTO} from '../_baseDTO.interface';

export interface CreateNegotiationDTO extends BaseDTO {
  advertId: string;
  contactId: string;
}
